<div class="wcg-float-config-panel" cdkDrag>
  @if (!$minimized()) {
    <section
      class="wcg-float-config-panel__body"
      animate.enter="wcg-float-config-panel__body--enter"
      animate.leave="wcg-float-config-panel__body--leave"
    >
      <button
        matMiniFab
        type="button"
        class="wcg-float-config-panel__reset"
        matTooltip="Reset all states"
        matTooltipPosition="right"
        aria-label="Reset all dashboard mock states"
        (click)="handleReset()"
      >
        <mat-icon [svgIcon]="icons.REFRESH" />
      </button>
      @for (group of $stripGroups(); track group.panelKey) {
        <hr class="wcg-float-config-panel__divider" aria-hidden="true" />
        <button
          type="button"
          class="wcg-float-config-panel__group-header"
          [class]="group.themeClass"
          [class.wcg-float-config-panel__group-header--open]="group.expanded"
          [matTooltip]="group.name"
          matTooltipPosition="right"
          [attr.aria-expanded]="group.expanded"
          [attr.aria-label]="group.name"
          [attr.data-testid]="
            'dashboard-config-panel__group--' + group.panelKey
          "
          (click)="handleGroupExpand(group.panelKey)"
        >
          <mat-icon [svgIcon]="group.icon" />
        </button>
        @if (group.expanded) {
          <ul
            class="wcg-float-config-panel__group"
            animate.enter="wcg-float-config-panel__group--enter"
            animate.leave="wcg-float-config-panel__group--leave"
          >
            @for (item of group.items; track item.stateKey) {
              <li class="wcg-float-config-panel__group-item">
                <button
                  matMiniFab
                  type="button"
                  class="wcg-float-config-panel__fab-btn"
                  [class]="item.themeClass"
                  [class.wcg-float-config-panel__fab-btn--active]="item.active"
                  [matTooltip]="item.tooltip"
                  matTooltipPosition="right"
                  [attr.aria-pressed]="item.active"
                  [attr.aria-label]="item.ariaLabel"
                  [attr.data-testid]="
                    'dashboard-config-panel__item--' +
                    group.panelKey +
                    '--' +
                    item.stateKey
                  "
                  (click)="handleToggleState(group.panelKey, item.stateKey)"
                >
                  <mat-icon [svgIcon]="item.icon" />
                </button>
              </li>
            }
          </ul>
        }
      } @empty {
        <p class="wcg-float-config-panel__empty">No components to configure</p>
      }
    </section>
  }
  <button
    matMiniFab
    type="button"
    class="wcg-float-config-panel__fab"
    [class.wcg-float-config-panel__fab--open]="!$minimized()"
    data-testid="dashboard-config-panel__toggle"
    cdkDragHandle
    [attr.aria-label]="
      $minimized()
        ? 'Expand dashboard config panel'
        : 'Minimize dashboard config panel'
    "
    (click)="toggleMinimized()"
  >
    <mat-icon [svgIcon]="icons.SYNC" />
  </button>
</div>
